import { Component } from 'react';
import service from '../../core/service';


interface IProps {

}

interface IState {
  tabValue: number;
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  headLineTitle: string;
  loading: boolean;
  categoriesList: Array<any>;
  subcategories: Array<any>;
  categorySelected?: any;
}

export class ToturialController extends Component<IProps, IState> {

 
  state: IState = {
    tabValue: 0,
    str: "",
    anchorEl: null,
    open: false,
    headLineTitle: "تقویم آموزشی",
    loading: false,
    categoriesList: [],
    subcategories: [],
    categorySelected: []
  };
  id: any = this.state.open ? 'simple-popper' : undefined;
  delayDebounceSearch: any;
  search = (e: any) => {
    this.setState({ str: e })
    clearTimeout(this.delayDebounceSearch);
    this.delayDebounceSearch = setTimeout(() => {
      this.getsubCategories()
    }, 1000);
  };
  handleChange = (event: any, newValue: number) => {
    this.setState({ tabValue: newValue, headLineTitle: event.target.textContent });
  };

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };

  handleClose = (event: any, cat: string) => {
    this.setState({ open: false, headLineTitle: event.target.innerText });
    this.getsubCategories(cat)
    
  };
  getCategoriesList = async () => {
    this.setState({ loading: true })
    try {
      const response = await service.Toturial.category();
      if (response) {
        this.setState({ categoriesList: response?.data?.data, loading: false, categorySelected: response?.data?.data?.[0] })
        this.getsubCategories(response?.data?.data[0])
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  getsubCategories = async (catItem = this.state.categorySelected, search = this.state.str) => {
    this.setState({ subcategories: [] })
    try {
      const response = await service.Toturial.subCategory(search, catItem?.id);
      if (response) {
        this.setState({ subcategories: response?.data?.data, categorySelected: catItem })
        // return response;
      } else {
      }
    } catch (error) {
      // throw error;
    }
  };
}
export default ToturialController;